module.exports = __webpack_public_path__ + "img/detailMouvements.f1219429.png";